// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070333/js/" + chunkId + "." + {"44":"96465626","225":"f5d2a86f","481":"3ee601a0","486":"21ff78c4","770":"56b95651"}[chunkId] + ".0.8257309343415337.chunk.js";
};